<template>
  <article>
    <div class="card relative" :class="cardBgColor">
      <div class="w-100 text-end" style="position: absolute; top:10px">
        <i class="mdi mdi-dots-vertical font-size-24 pe-1 pt-5" style="cursor: pointer"/>
      </div>
      <div class="card-body p-3">
        <div class="d-flex">
          <div class="avatar-xs">
            <span class="avatar-title rounded-circle bg-white text-deep-green"
                  style="font-size: 30px"
                  :class="`mdi ${iconImage}`">
            </span>
          </div>
          <span class="mt-2 ps-2 text-deep-green">{{ title }}</span>
        </div>

        <div class="float-end">
          <div class="text-align-end mt-4">
            <span class="ct-text-main fw-bold" style="font-size: 25px">
              <countTo :startVal="0" :endVal="endVal" :duration="1000" />
            </span>
            <span class="font-size-12 ct-text-muted">{{ valueTitle }}</span>
          </div>
          <div class="text-align-end mt-2">
            <template v-if="compared > 0">
              <span class="badge badge-soft-primary rounded-pill mdi mdi-arrow-up-bold ps-3 pe-3">{{ compared.toLocaleString() }}</span>
            </template>
            <template v-else-if="compared < 0">
              <span class="badge badge-soft-danger rounded-pill mdi mdi-arrow-down-bold ps-3 pe-3">{{ compared.toLocaleString() }}</span>
            </template>
            <template v-else>
              <span class="badge badge-soft-secondary rounded-pill ps-4 pe-4">{{ compared.toLocaleString() }}</span>
            </template>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import countTo from 'vue-count-to';

export default {
  components: { countTo },
  props: {
    iconImage: String,
    iconColor: {type: String, default: 'secondary'},
    title: String,
    valueTitle: String,
    endVal: {type: Number, default: 0},
    compared: {type: Number, default: 0},
    cardBg: String
  },
  computed: {
    cardBgColor() {
      return 'bg-' + this.cardBg + '-temp-gradient';
    }
  }
}
</script>
